import React from 'react';
import { Box, Grid } from "@mui/material";
import CustomizedAccordions from "./customizedAccordions";

const QuotingSubmenu = (props) => {
    const { item } = props;

    // Function to render content based on item properties
    const renderContent = () => {
        if (item.typography) {
            // Render typography content
            return <Box
                sx={{
                    display: 'inline-block',
                    width: '100%',
                    verticalAlign: 'top',
                    position: 'relative',
                    '& p': {
                        display: 'inline-block',
                        width: '100%',
                        verticalAlign: 'top',
                        fontFamily: 'body.fontFamily.secondary',  // Default font
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '28px',
                        textAlign: 'left',
                    },
                    '& p + p': {
                        fontFamily: 'body.fontFamily.primary',
                    },
                    '@media (max-width: 991px)': {
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: '-2em',
                            left: '0',
                            width: '100%',
                            height: '1px',
                            backgroundColor: 'rgb(0 0 0 / 80%)',
                        },
                    }
                }}
                dangerouslySetInnerHTML={{ __html: item.typography }} />;
        }

        // Render faqs accordions
        if (item?.faqs?.length > 0) {
            return <CustomizedAccordions item={item.faqs} />;
        }
    };

    return (
        <Grid item sm={12} md={12} lg={6}>
            <Box sx={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#3d4e57',
                margin: '0 0 10px 0',
                fontFamily: 'body.fontFamily.secondary',
                lineHeight: '24px'
            }}>
                {item.isShowHeader ? item.title : ""}
            </Box>
            <Box sx={{
                // display: 'inline-block',
                verticalAlign: 'top',
                width: '100%',
            }}>
                {/* Conditionally render content here */}
                {renderContent()}
            </Box>
        </Grid>
    );
};

export default QuotingSubmenu;